import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { NotificationsEntity } from '../notifications/notifications.entity';
import { ProfileEntity } from '../profile/profile.entity';
import { ProfileModule } from '../profile/profile.module';
import { VillageModule } from '../village/village.module';
import { RepresentationController } from './representation.controller';
import { RepresentationEntity } from './representation.entity';
import { RepresentationService } from './representation.service';
import { RepresentationFilesEntity } from './representationfiles.entity';

@Module({
  imports: [
    TypeOrmModule.forFeature([RepresentationEntity,RepresentationFilesEntity,NotificationsEntity]),
    ProfileModule,VillageModule
],
  controllers: [RepresentationController],
  providers: [RepresentationService],
  exports:[RepresentationService],
})
export class RepresentationModule {}
